import { ProductType } from '@/api/types';

export const isRandomMediaProduct = <T extends { type: ProductType }>(
  product: T
) => {
  return product.type === 'RANDOM_MEDIA';
};
